export default __webpack_public_path__ + "static/media/process99.4146c00d.svg";